//TOPのスライダー
var slider1 = new Swiper ('.slider1', {
  effect: 'slide',
  loop: true, // 最後のスライドの後は最初のスライドに戻るならtrue
  autoplay: {
    delay: 3000, // 自動再生する場合の実行間隔
    disableOnInteraction: false, // 矢印やスワイプでスライド切り替わった場合、自動再生を停止するか、再開したいのでfalse
  },
  speed: 500, // スライドの切り替わる時間
  centeredSlides: true,
  slidesPerView: 3,
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
      768: {
        slidesPerView: 1.5,
        spaceBetween: 16,
      },
      960: {
        slidesPerView: 3,
        spaceBetween: 16, 
      },
    },
  spaceBetween: 16,
  pagination: {
    el: '.swiper-pagination',
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});
//MENUのスライダー
var slider2 = new Swiper ('.slider2', {
  effect: 'slide',
  loop: true, // 最後のスライドの後は最初のスライドに戻るならtrue
  autoplay: {
    delay: 3000, // 自動再生する場合の実行間隔
    disableOnInteraction: false, // 矢印やスワイプでスライド切り替わった場合、自動再生を停止するか、再開したいのでfalse
  },
  speed: 500, // スライドの切り替わる時間
  centeredSlides: true,
  slidesPerView: 3,
    breakpoints: {
      320: {
        slidesPerView: 1.5,
      },
      768: {
        slidesPerView: 1.5,
      },
      960: {
        slidesPerView: 3,
      },
    },
  spaceBetween: 16,
  pagination: {
    el: '.swiper-pagination',
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});
//アコーディオンをクリックした時の動作
$('.down').on('click', function() {//タイトル要素をクリックしたら
  var findElm = $(this).next(".box");//直後のアコーディオンを行うエリアを取得し
  $(findElm).slideToggle();//アコーディオンの上下動作
    
  if($(this).hasClass('close')){//タイトル要素にクラス名closeがあれば
    $(this).removeClass('close');//クラス名を除去し
  }else{//それ以外は
    $(this).addClass('close');//クラス名closeを付与
  }
});
//HISTORYのスライダー
var slider4 = new Swiper ('.slider4', {
  slidesPerView: 6,
    breakpoints: {
      320: {
        slidesPerView: 3.3,
      },
      768: {
        slidesPerView: 3.3,
      },
      960: {
        slidesPerView: 6,
      },
    },
  spaceBetween: 10,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  scrollbar: {
    el: '.swiper-scrollbar',
  },
});
//商品ページのビューア―
$(function(){
  $("#slider").slick({
    asNavFor:"#thumbs"
  })
  $("#thumbs").slick({
    slidesToShow: 7,
    asNavFor:"#slider",
  })
  $("#thumbs .slick-slide").on("click",function(){
    let index=$(this).attr("data-slick-index")
    $("#slider").slick("slickGoTo",index)
  })
});
//10のポイントのスライダー
let slider3;
  function initSwiper() {
    slider3 = new Swiper('.slider3', {
      loop: true,
      speed: 1000,
      slidesPerView: 1,
      spaceBetween: 10,
      autoplay: false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: ".swiper-pagination",
        type: "progressbar",
        clickable: true
      },
      on: {
        init: function () {
          updateExtraPagination(this);
        },
        slideChange: function () {
          updateExtraPagination(this);
        }
      }
    });
  }

function updateExtraPagination(swiper) {
  const currentIndex = swiper.realIndex + 1;
  const totalSlides = swiper.el.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)').length;
  document.querySelector('.swiper-pagination-extra').textContent = `${currentIndex} / ${totalSlides}`;
}

  document.addEventListener('DOMContentLoaded', () => {
    initSwiper(); // まずSwiperインスタンスだけ作る

    const target = document.querySelector('.slider3');
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (slider3.autoplay && typeof slider3.autoplay.start === 'function') {
            slider3.autoplay.start(); // 見えたら再生
          }
          observer.unobserve(entry.target); // 一度きりでOK
        }
      });
    }, {
      threshold: 0.5
    });

    if (target) {
      observer.observe(target);
    }
  });

//SHOPINFOのスライダー
var slider5 = new Swiper ('.slider5', {
  loop: true, // ループ有効
  slidesPerView: 2.5, // 一度に表示する枚数
    breakpoints: {
      320: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 1.5,
      },
      960: {
        slidesPerView: 2.5,
      },
    },
  speed: 10000, // ループの時間
  allowTouchMove: false, // スワイプ無効
  autoplay: {
    delay: 0, // 途切れなくループ
  },
});